import {useState, useMemo} from 'react';
import {CalendarEvent} from './useEvents';
import { UserDetails } from '../types/schemas/abc';


export const useEventModal = (events: CalendarEvent[] | undefined, userDetails: UserDetails | null) => {
    const [selectedId, setSelectedId] = useState<string | null>(null);

    const selectedEvent = useMemo(() => {
        return events?.find(e => e.id === selectedId);
      }, [events, selectedId]);

    const avatar = useMemo(() => {
        if (!selectedEvent) return undefined;
        
        const isTutor = userDetails?.role === 'tutor';
        return {
          name: isTutor ? selectedEvent.parentName : selectedEvent.tutorName,
          photoUrl: isTutor ? undefined : selectedEvent.tutorProfilePhotoUrl,
          color: isTutor ? selectedEvent.parentProfileColor : undefined 
        };
      }, [selectedEvent, userDetails]);

      return {
        isOpen: !!selectedEvent,
        event: selectedEvent,
        avatar,
        openById: setSelectedId, // Expose the setter directly
        close: () => setSelectedId(null)
      };
};